import { render, staticRenderFns } from "./StationForm.vue?vue&type=template&id=1f981831&scoped=true"
import script from "./StationForm.vue?vue&type=script&lang=js"
export * from "./StationForm.vue?vue&type=script&lang=js"
import style0 from "./StationForm.vue?vue&type=style&index=0&id=1f981831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f981831",
  null
  
)

export default component.exports